import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import DashboardSectionTitle from '../../components/shared/DashboardSectionTitle';
import { formatPnl, formatQty, formatR, formatRisk, formatTradeTime } from './format';

export default function BacktestTradesTable({
  trades = [],
  selectedId,
  onSelect,
  stale = false,
}) {
  const { colors } = useTheme();
  const count = trades.length;
  return (
    <div data-testid="backtest-trades" style={{ opacity: stale ? 0.55 : 1 }}>
      <DashboardSectionTitle
        title="Trades"
        count={<span data-testid="backtest-trade-count">{count}</span>}
        marginBottom={8}
        as="h3"
      />
      {count === 0 ? (
        <div style={{ padding: '8px 4px 16px', color: colors.textMuted, fontSize: 12 }}>No trades yet</div>
      ) : (
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: 12,
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          <thead>
            <tr style={{ color: colors.textMuted, textAlign: 'left' }}>
              <th style={{ ...th, background: colors.bgCard }}>Time</th>
              <th style={{ ...th, background: colors.bgCard }}>Side</th>
              <th style={{ ...th, textAlign: 'right', background: colors.bgCard }}>Qty</th>
              <th style={{ ...th, textAlign: 'right', background: colors.bgCard }}>Risk</th>
              <th style={{ ...th, textAlign: 'right', background: colors.bgCard }}>R</th>
              <th style={{ ...th, textAlign: 'right', background: colors.bgCard }}>P&L</th>
            </tr>
          </thead>
          <tbody>
            {trades.map((trade) => {
              const active = selectedId === trade.id;
              const pnlColor = trade.pnl > 0 ? colors.success : trade.pnl < 0 ? colors.danger : colors.text;
              return (
                <tr
                  key={trade.id}
                  data-testid={`backtest-trade-${trade.id}`}
                  aria-selected={active}
                  onClick={() => onSelect?.(trade)}
                  style={{
                    cursor: 'pointer',
                    background: active ? `${colors.primary}22` : 'transparent',
                    color: colors.text,
                  }}
                >
                  <td style={td}>{formatTradeTime(trade.entryTime)}</td>
                  <td style={{ ...td, color: trade.side === 'long' ? colors.success : colors.danger, fontWeight: 700 }}>
                    {trade.side === 'long' ? 'L' : 'S'}
                  </td>
                  <td style={{ ...td, textAlign: 'right' }}>{formatQty(trade.qty)}</td>
                  <td style={{ ...td, textAlign: 'right' }}>{formatRisk(trade.risk)}</td>
                  <td style={{ ...td, textAlign: 'right' }}>{formatR(trade.rMultiple)}</td>
                  <td style={{ ...td, textAlign: 'right', color: pnlColor, fontWeight: 650 }}>{formatPnl(trade.pnl)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}

const th = { padding: '6px 4px', fontWeight: 600, fontSize: 10, letterSpacing: '0.06em', textTransform: 'uppercase', position: 'sticky', top: 0 };
const td = { padding: '7px 4px', borderTop: '1px solid rgba(255,255,255,0.04)', whiteSpace: 'nowrap' };
